export default "__VITE_ASSET__dfaa2ea9__"